import { X } from "lucide-react";
import { cn } from "@repo/utils/utils";
import {
  PendingChangeBadge,
  pendingChangeStyles,
  RelationTemplateProps,
} from "./view-component-renderer";

export const CardWithImage: React.FC<RelationTemplateProps> = ({
  config,
  onRemove,
  onEdit,
  pendingChange,
}) => {
  return (
    <div
      className={cn(
        "group flex items-center justify-between gap-2 rounded-md border border-input px-3 py-2",
        pendingChange && pendingChangeStyles,
      )}
    >
      <button type="button" className="flex flex-grow items-center gap-4" onClick={onEdit}>
        {config.image && (
          <div className="h-14 w-14">
            {config.image.startsWith("${") ? (
              <div className="h-full w-full place-content-center rounded-full bg-slate-200 text-center text-[8px]">
                {config.image}
              </div>
            ) : (
              <img className="h-full w-full object-cover" src={config.image} />
            )}
          </div>
        )}
        <div className="text-left">
          <p className="text-lg font-medium">{config.name}</p>
          <p className="-mt-1.5">{config.subname}</p>
          <p className="text-xs text-muted-foreground">{config.description}</p>
        </div>
      </button>
      {pendingChange && <PendingChangeBadge change={pendingChange} />}
      <button type="button" onClick={onRemove} className="opacity-0 group-hover:opacity-100">
        <X size={"1rem"} className="text-neutral-600" />
      </button>
    </div>
  );
};
